import { defineStore } from 'pinia';

import { Profile } from '@stuut/api/models';

import { stuut } from '@/api';
import { useFeatureFlags } from '@/store/featureFlags';

interface State {
  profile: Profile;
}

export const useProfile = defineStore('profile', {
  actions: {
    async fetchProfile(force = true): Promise<Profile> {
      if (this.profile.id && !force) return Promise.resolve(this.profile);

      return stuut.profile
        .retrieve()
        .then((profile) => {
          this.$patch({ profile });
          return this.profile;
        })
        .catch((err) => {
          console.error(err);
          return Promise.reject(err);
        });
    },
  },
  getters: {
    deductionsInbox: (state) => {
      const orgName = state.profile?.organization?.name?.toLowerCase();

      if (!orgName) return '';

      return `deductions+${orgName}@stuut.ai`;
    },

    hasBusinessUnits: (state) => {
      return state.profile?.organization?.has_business_units ?? false;
    },

    isDisputesEnabled: (state) => {
      return state.profile?.isDisputesEnabled;
    },

    isBaseDisputesEnabled: (state) => {
      return (
        Boolean(
          state.profile?.isDisputesEnabled || useFeatureFlags().flags['base-disputes-enabled'],
        ) || state.profile?.organization?.is_base_disputes_enabled
      );
    },

    // Base disputes only — the org has the base-disputes flag but not Disputes Pro.
    isDisputesBaseOnly: (state) => {
      return Boolean(
        useFeatureFlags().flags['base-disputes-enabled'] && !state.profile?.isDisputesEnabled,
      );
    },

    isMpgTypeDeduction: (state) => {
      const orgName = state.profile?.organization?.name?.toLowerCase();
      return orgName?.startsWith('mpg') || orgName === 'market-performance-group';
    },
  },

  state: (): State => ({
    profile: new Profile(),
  }),
});

export default useProfile;
